// src/store/index.js
import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import driverReducer from './slices/driverSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    driver: driverReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          'driver/updateMyLocation/pending',
          'driver/updateMyLocation/fulfilled',
          'driver/fetchMyStats/fulfilled',
          'driver/fetchMyEarnings/fulfilled'
        ],
        ignoredPaths: [
          'driver.locationUpdateInterval',
          'driver.lastUpdated',
          'driver.stats',
          'driver.earnings'
        ]
      }
    }),
  devTools: process.env.REACT_APP_ENV !== 'production'
});

console.log('✅ Redux Store configuré');

export default store;